import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { IndividualPayrocTerminalAccount } from './editPayrocTerminalAccount';

export interface PayrocTerminalAccountInfo extends IndividualPayrocTerminalAccount {
  merchantId: string;
}

export const getPayrocTerminalAccounts = (
  storeId: number,
): AxiosPromise<PayrocTerminalAccountInfo[]> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/stores/${storeId}/payroc/terminals`,
  });
};
